// extracted by mini-css-extract-plugin
export var card = "styles-module--card--f33de";
export var heading = "styles-module--heading--7cd6e";
export var images = "styles-module--images--383d4";
export var light = "styles-module--light--9d899";
export var profile = "styles-module--profile--f420a";
export var reactions = "styles-module--reactions--4e65f";
export var text = "styles-module--text--cb8d4";
export var title = "styles-module--title--76822";